export default "__VITE_ASSET__998c06b8__"